var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed top-0 left-0 w-full h-screen flex items-center justify-center z-50"},[_c('div',{staticClass:"bg-[#1B1B1B] absolute top-0 left-0 w-full h-screen z-0"}),_c('div',{staticClass:"bg-[#1B1B1B] absolute top-0 left-0 w-full h-screen z-0"}),_c('img',{staticClass:"z-[1] zoom",attrs:{"src":require("@/assets/images/miniLogo.png"),"alt":"Logo"}})])
}]

export { render, staticRenderFns }